/* eslint-disable */
import { checkIsMobile } from '@assets/js/utils';

const Toast = {};
let toastTimer = false; // toast定时器
let toastVm = null; // toast vm

Toast.install = function install(Vue, options) {
  // 默认的参数设置
  const defaultOps = {
    pos: 'center', // toast位置
    duration: '3000', // 持续时间,s
    wordWrap: false // 默认不自动换行
  };

  Object.keys(options).forEach((item) => {
    // 插件注册时候有设置options，采用传入的options
    defaultOps[item] = options[item];
  });

  Vue.prototype.$toast = function $toast(msg, opts) {
    // 添加$toast实例方法
    let optionsActive = {};
    if (opts) {
      const curOptions = JSON.parse(JSON.stringify(opts));
      if (typeof curOptions === 'object') {
        // 如果传入的是对象
        Object.keys(curOptions).forEach((item) => {
          optionsActive[item] = curOptions[item];
        });
      }
    } else {
      optionsActive = defaultOps;
    }
    if (toastTimer) {
      clearTimeout(toastTimer);
      toastVm.show = false;
    }
    if (!toastVm) {
      const ToastTpl = Vue.extend({
        data() {
          return {
            show: false,
            msg, // toast消息
            pos: optionsActive.pos,
            wordWrap: optionsActive.wordWrap
          };
        },
        render(h) {
          if (!this.show) {
            return false;
          }
          return h('div', {
            class: [
              'bg-toast',
              `bg-toast-${this.pos}`,
              this.wordWrap ? 'bg-word-wrap' : '',
              checkIsMobile() ? 'mobile' : ''
            ],
            show: this.show,
            domProps: {
              innerHTML: this.msg
            }
          });
        }
      });
      toastVm = new ToastTpl();
      const tpl = toastVm.$mount().$el;
      document.body.appendChild(tpl);
    }

    toastVm.msg = msg;
    toastVm.wordWrap = optionsActive.wordWrap;
    toastVm.pos = optionsActive.pos;
    toastVm.show = true;

    toastTimer = setTimeout(() => {
      toastVm.show = false;
      toastTimer = false;
    }, optionsActive.duration);
  };
};

export default Toast;
